/**
 * Ads List Subscription Route - React Router v7
 *
 * Route: /renting/*
 * Description: Renting (subscription) ads listing
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../helpers/navigationStateCache.ts'
import {withRouter} from '../../hocs/withRouter'
import {withThirdPartiesParam} from '../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps.js'
import AdsListSubscriptionComponent from './index.js'

// Import styles
import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const AdsListSubscription = withThirdPartiesParam(AdsListSubscriptionComponent)

const AdsListSubscriptionWithRouter = withRouter(AdsListSubscription)

/**
 * Loader for Ads List Subscription page
 * Fetches search results for saved subscriptions
 */
export async function loader({context, request, params}: LoaderFunctionArgs) {
  if (!context) {
    throw new Error('[RR7] AdsListSubscription: context is required')
  }

  const url = new URL(request.url)
  const pathname = url.pathname
  const search = url.search
  const queryParams = Object.fromEntries(url.searchParams)

  const routeInfo = {
    location: {
      pathname,
      query: queryParams,
      search,
      // `lastFilter` and `origin` travel in the navigation state; RR7 keeps it out of
      // `LoaderFunctionArgs` (see helpers/navigationStateCache.ts).
      state: getNavigationState(pathname)
    }
  }

  try {
    const initialProps = await getInitialProps({
      routeInfo,
      context
    })

    return {
      ...initialProps,
      __RR7__: true
    }
  } catch (error: unknown) {
    console.error('[RR7] AdsListSubscription loader error:', error)
    throw error
  }
}

/**
 * Component wrapper for RR7
 */
export function Component() {
  const data = useLoaderData()

  return <AdsListSubscriptionWithRouter {...data} />
}

Component.displayName = 'AdsListSubscriptionRoute'
